import z from 'zod'

export const CreateUpdateFarmSchema = z
	.object({
		name: z.string(),
		id: z.string(),
	})
	.transform((data) => data.id)
